import React, { Component } from 'react'
import PropTypes from 'prop-types'
import css from './style.css'
import { Grid, GridItem } from '../grid'
import Spacer from '../spacer'
import Button from '../button'
import Price from '../price'
import { JewelryName } from '../item-header'
import ToggleDisplay from '../toggle-display'
import JewelryPriceBreakdown from '../jewelry-price-breakdown'

class JewelryPrice extends Component {
  constructor (props) {
    super(props)
    this.state = {
      priceVisible: false
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({priceVisible: nextProps.result && nextProps.result['total_price'] !== undefined})
  }

  componentWillUnmount () {
    this.props.clearCurrentJewelry()
  }

  addable () {
    return this.state.priceVisible && this.props.currentJewelryPriceIsFresh
  }

  render () {
    return (
      <div>
        <Grid customStyle={css.topGrid}>
          <GridItem col='2/10'>
            <div className={css.name}><JewelryName /></div>
          </GridItem>
          <GridItem col='8/10'>
            <GridItem nopad col='2/10'>
              <Button buttonId={'calculate_price_btn'} alt fixedWidth onClick={this.props.onGetPrice}>Calculate Price</Button>
            </GridItem>
            <GridItem col='8/10'>
              {this.props.errorMsg}
            </GridItem>
          </GridItem>
        </Grid>
        <Grid customStyle={css.bottomGrid}>
          <GridItem col='2/10'>
            <ToggleDisplay show={this.state.priceVisible}>
              <div className={css.priceHeading}>Cost</div>
              <div className={css.price}>
                {this.props.price && <Price productType='jewelry' price={this.props.price} styleClass={css.price} />}
              </div>
              <Spacer xs />
            </ToggleDisplay>
          </GridItem>
          <GridItem col='8/10'>
            <Button tall fixedWidth buttonId={'add_as_new_item_btn'} disabled={!this.addable()} onClick={this.props.addJewelryClicked}>Add as New Item</Button>
          </GridItem>
        </Grid>
        {this.props.user && this.props.user.admin &&
          <JewelryPriceBreakdown {...this.props} priceVisible={this.state.priceVisible} />
        }
      </div>
    )
  }
}

JewelryPrice.propTypes = {
  price: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  currentJewelryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  currentJewelryNumber: PropTypes.number,
  currentJewelryPriceIsFresh: PropTypes.bool,
  addJewelryClicked: PropTypes.func.isRequired,
  clearCurrentJewelry: PropTypes.func.isRequired
}

export default JewelryPrice



// WEBPACK FOOTER //
// ./src/components/jewelry-price/index.js